/* ============================================================
   IMAGE OPTIMIZER — CONSTANTS & MOCK DATA (FRONTEND ONLY)
   All configuration values, limits, messages, plans, and mock
   helpers for the Image Optimizer page live here.
   ============================================================ */

/* ------------------------------------------------------------
   DESIGN TOKENS
   ------------------------------------------------------------ */
export const TOKENS = {
  primary: "#861b68",
  primary2: "#a32480",
  text: "#000000",
  bg: "#ffffff",
  bgSubtle: "#fafafa",
  border: "#eeeeee",
  borderStrong: "#c9c9c9",
  error: "#b3261e",
  errorBg: "#fdecea",
};

/* ------------------------------------------------------------
   UPLOAD RULES
   ------------------------------------------------------------ */
export const ACCEPTED_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const ACCEPTED_TYPES_LABEL = "JPG, JPEG, PNG, WEBP";
export const ACCEPT_ATTR = "image/jpeg,image/jpg,image/png,image/webp";

/* ------------------------------------------------------------
   OPTIMIZATION SETTINGS
   ------------------------------------------------------------ */
export const MAX_DIMENSION = 1600;
export const LARGE_FILE_THRESHOLD = 1.5 * 1024 * 1024; // 1.5 MB
export const QUALITY_HIGH = 0.92;
export const QUALITY_MEDIUM = 0.82;
export const QUALITY_LOW = 0.74;

/* ------------------------------------------------------------
   USER-FACING MESSAGES
   ------------------------------------------------------------ */
export const MSG_UNSUPPORTED_FORMAT =
  "Unsupported image format. Please upload JPG, JPEG, PNG, or WEBP.";
export const MSG_UNREADABLE =
  "Image could not be processed. Please try another image.";
export const MSG_OPTIMIZATION_FAILED =
  "Image optimization failed. Please replace the image and try again.";

// Set to true only during local development to reveal test controls.
export const SHOW_DEV_CONTROLS = false;

/* ------------------------------------------------------------
   PLANS & LIMITS
   ------------------------------------------------------------ */
export const FREE_UPLOAD_LIMIT = 20;
export const FREE_POSTING_LIMIT = 6;
export const PLANS = [
  { id: "starter", name: "Starter Plan", uploadLimit: 20, postingLimit: 12, price: "₹149" },
  { id: "pro", name: "Pro Plan", uploadLimit: 20, postingLimit: 20, price: "₹299" },
];

/* ------------------------------------------------------------
   STATUS LABELS & STYLE CLASSES
   ------------------------------------------------------------ */
export const STATUS_LABELS = {
  uploading: "Uploading...",
  optimizing: "Optimizing image...",
  ready: "Optimization Complete",
  error: "Optimization Failed",
  posted: "Posted",
};

export const statusClassFor = (status) => ({
  uploading: "OptimizerStatusUploading",
  optimizing: "OptimizerStatusOptimizing",
  ready: "OptimizerStatusReady",
  posted: "OptimizerStatusPosted",
  error: "OptimizerStatusError",
}[status] || "");

/* ------------------------------------------------------------
   MOCK DATA (development only helpers, see SHOW_DEV_CONTROLS)
   ------------------------------------------------------------ */
export function createMockFile(width, height, label) {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, width, height);
    gradient.addColorStop(0, TOKENS.primary);
    gradient.addColorStop(1, TOKENS.primary2);
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = "#ffffff";
    ctx.font = `${Math.max(18, Math.round(width / 12))}px sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(label, width / 2, height / 2);
    canvas.toBlob(
      (blob) => {
        resolve(
          new File([blob], `${label.toLowerCase().replace(/\s+/g, "-")}.jpg`, {
            type: "image/jpeg",
          })
        );
      },
      "image/jpeg",
      0.9
    );
  });
}
